export class WorkAttachmentAddEvent {
    workId: string;
    id: string;
    name: string;
    fullUrl: string;
    error ?: string;
}